// Master list of languages CometQR can show diners. A venue enables a subset via
// venue.diner_languages (CSV, primary first); adding a language here makes it selectable
// everywhere. Menu text comes from each item's flexible `translations` map, so any code here
// works as soon as the owner types it — no schema change per language.
export const MASTER_LANGS = [
  { code: 'en', label: 'English' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'de', label: 'Deutsch' },
  { code: 'th', label: 'ไทย' },
  { code: 'km', label: 'ភាសាខ្មែរ' },
  { code: 'lo', label: 'ພາສາລາວ' },
  { code: 'ms', label: 'Bahasa Melayu' },
  { code: 'ru', label: 'Русский' },
  { code: 'fr', label: 'Français' },
  { code: 'es', label: 'Español' },
  { code: 'it', label: 'Italiano' },
  { code: 'pt', label: 'Português' },
  { code: 'ar', label: 'العربية' },
  { code: 'zh', label: '中文' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'uz', label: 'Oʻzbekcha' },
];

export const MASTER_CODES = MASTER_LANGS.map((l) => l.code);

// Legacy default for venues that haven't chosen languages yet (diner_languages = NULL): keep the
// original English / Thai / Russian behaviour so existing menus are unchanged.
export const LEGACY_DEFAULT = ['en', 'th', 'ru'];

// Parse a venue's diner_languages CSV → ordered list of enabled codes (primary first).
// Unset/empty → LEGACY_DEFAULT. Always keeps only known master codes.
export function venueLangCodes(dinerLanguages) {
  if (!dinerLanguages || typeof dinerLanguages !== 'string') return LEGACY_DEFAULT;
  const codes = dinerLanguages
    .split(',')
    .map((s) => s.trim().toLowerCase())
    .filter((c) => MASTER_CODES.includes(c));
  return codes.length ? codes : LEGACY_DEFAULT;
}
